/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Scope_PlanInputs */

const en_us2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap it in the plan too`)
};

const pt_br2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar no plano também`)
};

const es_419_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiarlo también en el plan`)
};

const pt_pt2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar também no plano`)
};

const fr_fr2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer aussi dans le programme`)
};

const de_de2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch im Plan tauschen`)
};

const it_it2_workout_swap_scope_plan = /** @type {(inputs: Workout_Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia anche nella scheda`)
};

/**
* | output |
* | --- |
* | "Swap it in the plan too" |
*
* @param {Workout_Swap_Scope_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_plan = /** @type {((inputs?: Workout_Swap_Scope_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_plan(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_plan(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_plan(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_plan(inputs)
	return en_us2_workout_swap_scope_plan(inputs)
});
export { workout_swap_scope_plan as "workout-swap.scope_plan" }